import { render, staticRenderFns } from "./default.vue?vue&type=template&id=b2763406&"
import script from "./default.vue?vue&type=script&lang=ts&"
export * from "./default.vue?vue&type=script&lang=ts&"
import style0 from "./default.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CookieConsent: require('/Users/markussh/git/theodora-tech-website/src/components/misc/CookieConsent.vue').default,AnimateAppReveal: require('/Users/markussh/git/theodora-tech-website/src/components/animate/AppReveal.vue').default,SkipToContent: require('/Users/markussh/git/theodora-tech-website/src/components/misc/SkipToContent.vue').default})
